import React, { useState } from "react";
import { FaGithub, FaLinkedin, FaAngellist } from "react-icons/fa";
const FloatingButton = () => {
  const [show, setShow] = useState(false);

  const handleClick = () => {
    setShow(!show);
  };

  const icons = [
    {
      id: 1,
      icon: <FaGithub className="dark:text-blue-600" />,
      url: "https://github.com/mwafrika",
    },
    {
      id: 2,
      icon: <FaLinkedin className="dark:text-blue-600" />,
      url: "https://www.linkedin.com/in/mwafrika-mufungizi",
    },
    {
      id: 3,
      icon: <FaAngellist className="dark:text-blue-600" />,
      url: "https://angel.co/u/mwafrika-mufungizi",
    },
  ];

  return (
    <div data-dial-init className="fixed top-6 left-6 group md:hidden">
      <button
        type="button"
        data-dial-toggle="speed-dial-menu-top-right"
        aria-controls="speed-dial-menu-top-right"
        aria-expanded="false"
        onClick={handleClick}
        className="flex items-center justify-center text-white bg-blue-700 rounded-full w-10 h-10 hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:focus:ring-blue-800"
      >
        <svg
          aria-hidden="true"
          className="w-8 h-8 transition-transform group-hover:rotate-45"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          ></path>
        </svg>

        <span className="sr-only">Open actions menu</span>
      </button>

      <div
        id="speed-dial-menu-top-right"
        className={`${
          show ? "flex" : "hidden"
        } flex-col items-center mt-4 space-y-2`}
      >
        <ul className="flex flex-col items-center space-y-4">
          {icons.map(({ id, icon, url }) => (
            <li
              key={id}
              className="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 dark:border-gray-600 shadow-sm dark:hover:text-white dark:text-gray-400 hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 focus:outline-none dark:focus:ring-gray-400"
            >
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 -ml-px"
              >
                <span>{icon}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FloatingButton;
